import { render, staticRenderFns } from "./AnswerAreaV3Math.vue?vue&type=template&id=60510a82&scoped=true&lang=pug&"
import script from "./AnswerAreaV3Math.vue?vue&type=script&lang=ts&"
export * from "./AnswerAreaV3Math.vue?vue&type=script&lang=ts&"
import style0 from "./AnswerAreaV3Math.vue?vue&type=style&index=0&id=60510a82&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60510a82",
  null
  
)

export default component.exports